<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title">
        <h2>{{ $t('genoPerformance.performanceOfGenoType') }}</h2>
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          dark
          :to="{ name: 'GenoRegistration' }"
        >
        {{ $t('genoPerformance.addAGenoType') }}
        </v-btn>
      </div>
      <!---------------------- Tablet screen ------------------------------>
      <!-- start -->
      <v-card
        class="px-4"
        :class="loading ? '' : 'py-1'"
        v-if="checkBreakPoints"
        elevation="0"
        :loading="loading"
      >
        <div class="d-flex mt-5">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            outlined
            height="5px"
            placeholder="Search"
            dense
            v-model="search"
            @click:append="searchGenos"
            @input="resetSearchOnEmpty"
            class="shrink"
          ></v-text-field>
          <v-btn
            :disabled="search.length < 1"
            color="primary"
            height="40"
            width="40"
            max-width="40"
            outlined
            class="ml-8"
            @click="searchGenos"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <div class="py-1 title">
            {{ from }} - {{ to }} of {{ totalgenos }}
          </div>
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            :disabled="tabletTableOptions.page <= 1"
            @click="tabletPageChange(false)"
          >
            <v-icon dark> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            :disabled="tabletTableOptions.page >= totalPages"
            @click="tabletPageChange(true)"
          >
            <v-icon dark> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
        <v-card
          class="inner-card my-4"
          v-for="(item, index) in items"
          :key="item.farmNumber"
          :elevation="0"
          :style="
            index % 2 !== 0 && { backgroundColor: 'rgba(243, 243, 243, 0.5)' }
          "
          @click="
            $router.push({
              name: 'GenoTypeView',
              params: { id: item.GTPerformanceNumber },
            })
          "
        >
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">Breed Name</v-col>
            <v-col md="6" style="color: #787878">{{ item.breedName }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">Chromosome</v-col>
            <v-col md="6" style="color: #787878">{{ item.chromosome }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">Sequence Change</v-col>
            <v-col md="6" style="color: #787878">{{
              item.sequenceChange
            }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">Inheritance</v-col>
            <v-col md="6" style="color: #787878">{{ item.inheritance }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">Disease Name</v-col>
            <v-col md="6" style="color: #787878">{{ item.diseaseName }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">Reference Sequence</v-col>
            <v-col md="6" style="color: #787878">{{
              item.referenceSequence
            }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">Pubmed Reference</v-col>
            <v-col md="6" style="color: #787878">{{
              item.pubmedReference
            }}</v-col>
          </v-row>
        </v-card>
      </v-card>
      <!------------------- end ------------------------------>
      <v-card v-else elevation="10" class="px-5">
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="genotypePerformances"
            v-model="selected"
            show-select
            item-key="GTPerformanceNumber"
            :items-per-page="10"
            :loading="$apollo.loading"
            :loading-text="$t('loadingPleaseWait')"
            :hide-default-footer="true"
            :footer-props="{
              'items-per-page-options': [5, 10, 25],
              'show-first-last-page': true,
              'show-current-page': true,
            }"
            :options.sync="tableOptions"
            :server-items="totalgenos"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  :placeholder="$t('search')"
                  dense
                  v-model="search"
                  @click:append="searchGenos"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchGenos"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} {{ $t('of') }} {{ totalgenos }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <!-- <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn> -->
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="8"
                indeterminate
              ></v-progress-linear>
            </template>
            <template
              v-if="genotypePerformances.length > 0"
              v-slot:body="{ items }"
            >
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.GTPerformanceNumber"
                  style="position: relative; width: 0; height: 0"
                >
                  <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td>
                  <td>{{ getBreedName(item.breedId) }}</td>
                  <td>{{ item.chromosome }}</td>
                  <td>{{ item.sequenceChange }}</td>
                  <td>{{ item.inheritance }}</td>
                  <td>{{ item.diseaseName }}</td>
                  <td>{{ item.referenceSequence }}</td>
                  <td>{{ item.pubmedReference }}</td>
                  <td style="position: absolute; right: 10px; top: 4px">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="editGTPerformance(item)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                      </template>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          @click="deleteGTPerformance(item)"
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          >mdi-trash-can</v-icon
                        >
                      </template>
                      <span>{{ $t('geneticsAndBreeding.delete') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <DeletePopup
      :dialogI="showDeleteDialog"
      v-if="showDeleteDialog"
      @delete="onDelete"
      @closeDialog="closeDeleteDialog"
    />
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import gql from "graphql-tag";
import { breeds } from "@/graphql/Animals.gql";
import DeletePopup from "./DeletePopup.vue";
export default {
  apollo: {
    genotypePerformances: {
      query: gql`
        query GetGenotypePerformances($queryData: GetQueryDataArgs!) {
          genotypePerformances(queryData: $queryData) {
            count
            rows {
              id
              breedId
              chromosome
              sequenceChange
              inheritance
              diseaseName
              referenceSequence
              pubmedReference
            }
            totalCount
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          queryData: {
            page: this.tableOptions.page,
            limit: this.tableOptions.itemsPerPage,
            searchPhrase: this.search,
          },
        };
      },
      update: (data) => data.genotypePerformances.rows,
      result({ data }) {
        this.totalgenos = data.genotypePerformances.totalCount;
        this.totalPages = Math.ceil(
          this.totalgenos / this.tableOptions.itemsPerPage
        );
        this.from =
          (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        this.to =
          this.tableOptions.page * this.tableOptions.itemsPerPage -
          (this.tableOptions.itemsPerPage - data.genotypePerformances.count);
      },
    },
    breeds: {
      query: breeds,
    },
  },
  components: {
    breadcrumb: Breadcrumb,
    DeletePopup,
  },
  watch: {
    tableOptions: {
      handler() {
        this.$apollo.queries.genotypePerformances.refetch();
      },
      deep: true,
    },
  },
  created() {
    if (this.checkBreakPoints) this.getTabletGenos();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  async mounted() {
    document.title = "GenoType";
    // await this.getGenos()
  },
  methods: {
    getBreedName(breedId) {
      return this.breeds.filter((item) => item.id == breedId)[0].name;
    },

    searchGenos() {
      if (this.search == "") return;

      this.$apollo.queries.genotypePerformances.refetch();
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletGenos();
      } else {
        this.tableOptions.page = 1;
        this.getGenos();
      }
    },

    getTabletGenos() {},
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;
      this.getGenos();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getTabletGenos();
    },
    
    editGTPerformance(item){
      const params={id:item.id};
      this.$router.push({name:"GenoTypeEdit",params});
    },

    deleteGTPerformance(item) {
      console.log("here", item);
      this.showDeleteDialog = true;
      this.selectedItem = item;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
    },
    async onDelete() {
      this.startLoading();
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation deleteGenotypePerformanceRecord($data: Int!) {
              deleteGenotypePerformanceRecord(id: $data)
            }
          `,
          variables: {
            data: parseInt(this.selectedItem.id),
          },
        })
        .then( (res) => {
          this.$notify({
              title: `Genotype Performance deleted successfully`,
              text: res.message,
              type: "success",
              position: "top right",
            });
            this.stopLoading();
            this.showDeleteDialog = false;
            this.$apollo.queries.genotypePerformances.refetch();
        })
        .catch((error)=>{
          console.log(error);
          this.stopLoading();
          
        });
    },
  },
  data() {
    return {
      showDeleteDialog: false,
      from: 0,
      to: 0,
      totalPages: 1,
      showingRows: 0,
      currentrows: 0,
      search: "",
      selected: [],
      genotypePerformances: [],
      totalgenos: 1,
      selectedItem: null,
      loading: false,
      pageCount: 0,
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      loadingText: "Loading... Please wait",
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('genoPerformance.performanceOfGenoType'),
          disabled: true,
        },
      ],
      headers: [
        {
          text: this.$t("genoPerformance.breed"),
          align: "start",
          value: "breedId",
        },
        { text: this.$t("genoPerformance.chromosome"), value: "chromosome" },
        { text: this.$t("genoPerformance.sequenceChange"), value: "sequenceChange" },
        { text: this.$t("genoPerformance.inheritance"), align: "center", value: "inheritance" },
        { text: this.$t("genoPerformance.diseaseName"), align: "center", value: "diseaseName" },
        {
          text: this.$t("genoPerformance.referenceSequence"),
          align: "center",
          value: "referenceSequence",
        },
        { text: this.$t("genoPerformance.pubmedReference"), value: "pubmedReference", align: "center" },
      ],
      // users: [],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}
</style>
